import React from 'react';
import SellerRating from './seller-rating';

const SellerLink = ({
    className,
    sellerMemberId,
    sellerAlias,
    prettifyRating
}) => {
    const { rating, includeTotal, noRating, isGood, isBad } = prettifyRating;
    return (
        <span className={className}>
            <a href={`/profile/feedback/${sellerMemberId}/${sellerAlias}`}>
                {sellerAlias}
            </a>
            {!noRating && (
                <>
                    &nbsp;
                    <SellerRating
                        rating={rating}
                        includeTotal={includeTotal}
                        isGood={isGood}
                        isBad={isBad}
                    />
                </>
            )}
        </span>
    );
};
export default SellerLink;
